<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i> Categories</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
              <router-link v-bind:to="{name: 'add-category' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <categories-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="categories" v-bind:actions="true"></categories-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import CategoryRepo from '../../repos/CategoryRepo'
import lodash from 'lodash'
import CategoriesTable from "./Table";

export default {
  name: 'categories-view',
  components: {CategoriesTable},
  data() {
        return {
            repo: new CategoryRepo(this.$auth),
            categories: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getCategories();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getCategories();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getCategories();
    },
    onPageChanged(page){
        this.page = page;        
        this.getCategories();
    },
    getCategories(){
        this.repo.paginate(this.page, this.q, this.orderBy).then(response => {            
            this.categories = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/categories/View.vue